import { Avatar, Text, Tooltip } from '@mantine/core';
import React from 'react';
import { Facilitator } from '.';
import { ApiService } from '../../../constants';

interface FacilitatorItemProps extends Facilitator {
  type?: 'default' | 'more';
  onClick?: () => void;
  total?: number;
}

const FacilitatorItem: React.FC<FacilitatorItemProps> = ({
  email,
  facilitatorname,
  urlprofile,
  userid,
  onClick,
  total,
  type = 'default'
}) => {
  if (type === 'more')
    return (
      <Tooltip label={'More'} withArrow>
        <span onClick={onClick} style={{ cursor: 'pointer' }}>
          <Avatar
            alt="More Facilitator"
            bg="#F7DFF9"
            color="#7B2183"
            radius="xl"
          >
            <Text fz={12} fw={700}>
              +{total}
            </Text>
          </Avatar>
        </span>
      </Tooltip>
    );

  return (
    <Tooltip label={facilitatorname} withArrow>
      <Avatar
        alt={email}
        src={ApiService.beelajar.getImageMoodle(urlprofile)}
        radius="xl"
      />
    </Tooltip>
  );
};

export default FacilitatorItem;
